import { request, RespError, handleFormatRes, date2TimestampStr, formatFaceUrlNickname } from '../../utils';
import { QRY_USER_QUAL } from '../../config/url';
/**
 * 查询用户资格信息汇总类型
 */
export var QryUserQualQueryType;
(function (QryUserQualQueryType) {
    /** 查询整个有效期汇总 */
    QryUserQualQueryType[QryUserQualQueryType["querySum"] = 1] = "querySum";
    /** 查询周期内汇总，默认值 */
    QryUserQualQueryType[QryUserQualQueryType["queryInterval"] = 0] = "queryInterval";
})(QryUserQualQueryType || (QryUserQualQueryType = {}));
;
// 需要转成 int 型的 key 数组
const needParseIntKey = [
    'qualType',
    'totalCnt',
    'usedCnt',
    'userMaxCnt',
    'intervalTotalCnt',
    'intervalUsedCnt',
    'allTotalCnt',
    'allUsedCnt',
];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['exchStartTime', 'exchEndTime'];
/**
 * 查询用户资格信息
 *
 * 查询用户的资格信息，资格数量与资格卡基本信息
 *
 * 接口地址：`/app/promotion/prom_qry_user_qual.cgi`
 *
 * @param qualId 资格id
 * @param startTime 开始时间
 * @param endTime 结束时间
 * @returns
 */
export async function qryUserQual({ qualId, startTime, endTime, qryAllInfo = QryUserQualQueryType.queryInterval, }) {
    try {
        // 参数格式化
        let params = {
            t: new Date().getTime(),
            qual_id: qualId,
            qry_all_info: qryAllInfo,
        };
        if (startTime) {
            params = Object.assign({}, params, {
                start_time: date2TimestampStr(startTime),
            });
        }
        if (endTime) {
            params = Object.assign({}, params, {
                end_time: date2TimestampStr(endTime),
            });
        }
        // 接口请求
        const result = await request.get(QRY_USER_QUAL, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    transformer: (res) => (Object.assign(Object.assign({}, res), formatFaceUrlNickname(res.faceUrl, res.nickName))),
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
